import { Funnel } from './Funnel'

const instance = Funnel.get()
export const useFunnel = (name?: string) => {
  if (name) {
    instance.setFunnelName(name)
  }
  return instance
}
